import MyScheduleHeader from './components/MyScheduleHeader/MyScheduleHeader';
import MyScheduleCalendar from './components/MyScheduleCalendar/MyScheduleCalendar';
import { EventsScheduleRef } from '../ScheduleCalendar/ScheduleCalendar';
import { forwardRef } from 'react';

const MySchedule = forwardRef<EventsScheduleRef, { pageToLoad: string }>(
  ({ pageToLoad }, ref) => {
    return (
      <div className='overflow-hidden'>
        <MyScheduleHeader />
        <MyScheduleCalendar pageToLoad={pageToLoad} ref={ref} />
      </div>
    );
  }
);

export default MySchedule;
